import { useEffect, useState } from "react";
import { Table, Tag, Button, Typography } from "antd";
import { FolderOpenOutlined } from "@ant-design/icons";

const { Text } = Typography;

const NAVY = "#042956";

function estadoColor(estado = "") {
  const e = estado.toLowerCase();
  if (e.includes("final") || e.includes("cerrad") || e.includes("complet")) return "green";
  if (e.includes("ejecu") || e.includes("proceso") || e.includes("curso")) return "blue";
  if (e.includes("pend") || e.includes("espera")) return "gold";
  if (e.includes("suspend") || e.includes("cancel")) return "red";
  return "default";
}

/**
 * ProyectosTable
 * Props:
 *  - proyectos: mismo shape que ProyectosCards
 *  - loading: boolean
 *  - onSelect(proyecto)
 */
export default function ProyectosTable({ proyectos = [], loading = false, onSelect }) {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  // Si cambian los filtros (nuevo array), vuelve siempre a la primera página.
  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [proyectos]);

  const columns = [
    {
      title: "Código",
      dataIndex: "codigo",
      key: "codigo",
      width: 100,
      fixed: "left",
      render: (codigo) => (
        <span
          style={{
            background: NAVY,
            color: "#ffffff",
            fontWeight: 700,
            fontSize: 12,
            padding: "3px 10px",
            borderRadius: 6
          }}
        >
          {codigo}
        </span>
      )
    },
    {
      title: "Proyecto",
      dataIndex: "proyecto",
      key: "proyecto",
      width: 260,
      render: (proyecto) => (
        <Text style={{ color: NAVY, fontWeight: 500 }} ellipsis title={proyecto}>
          {proyecto}
        </Text>
      )
    },
    {
      title: "Proyecto asociado",
      dataIndex: "Nombre_proyectoAsociado",
      key: "Nombre_proyectoAsociado",
      width: 220,
      render: (v) => (
        <Text style={{ color: "#5b6b7c" }} ellipsis title={v}>
          {v || "—"}
        </Text>
      )
    },
    {
      title: "Implementador",
      dataIndex: "implementador",
      key: "implementador",
      width: 170,
      render: (v) => <Text style={{ color: "#5b6b7c" }} ellipsis title={v}>{v || "—"}</Text>
    },
    {
      title: "Operador",
      dataIndex: "operador",
      key: "operador",
      width: 150,
      render: (v) => <Text style={{ color: "#5b6b7c" }} ellipsis title={v}>{v || "—"}</Text>
    },
    {
      title: "Tipo beneficiario",
      dataIndex: "tipo_beneficiario",
      key: "tipo_beneficiario",
      width: 150,
      render: (v) => <Text style={{ color: "#5b6b7c" }} ellipsis title={v}>{v || "—"}</Text>
    },
    {
      title: "Estado",
      dataIndex: "ac_estado",
      key: "ac_estado",
      width: 130,
      render: (estado) => (
        <Tag color={estadoColor(estado)} style={{ borderRadius: 6, fontWeight: 500 }}>
          {estado || "Sin estado"}
        </Tag>
      )
    },
    {
      title: "Acción",
      key: "accion",
      width: 160,
      fixed: "right",
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          icon={<FolderOpenOutlined />}
          onClick={() => onSelect?.(record)}
          style={{ background: NAVY, borderRadius: 8, fontWeight: 500 }}
        >
          Ver documentos
        </Button>
      )
    }
  ];

  return (
    <div
      style={{
        background: "#ffffff",
        borderRadius: 16,
        padding: 8,
        border: "1px solid #eef1f5",
        boxShadow: "0 1px 4px rgba(4, 41, 86, 0.06)"
      }}
    >
      <Table
        rowKey="oid"
        loading={loading}
        columns={columns}
        dataSource={proyectos}
        scroll={{ x: 1200 }}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: proyectos.length,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
          showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} proyectos`,
          onChange: (current, pageSize) => setPagination({ current, pageSize })
        }}
      />
    </div>
  );
}
